export interface HousingCorporationsListResult extends Array<Item> {}

interface Item {
  _id: string
  name: string
  address: string
  comment?: string
  municipality: string
  location: Location
  parentId: string
  __v: number
  ready: boolean
}

interface Location {
  lat: number
  long: number
}

export default function getHousingCorporations(
  {get}: any,
  {projectId}: {projectId: number},
): Promise<HousingCorporationsListResult> {
  return get(`/housing-corporations`, {projectId}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/getHousingCorporations.tsx